/* eslint-disable no-control-regex */
export const emailRegex =
  /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:\\[\x00-\x7F]|[^\r\n"\\])*")@(?:[a-zA-Z0-9\u00C0-\u024F\u1E00-\u1EFF](?:[a-zA-Z0-9\u00C0-\u024F\u1E00-\u1EFF-]{0,61}[a-zA-Z0-9\u00C0-\u024F\u1E00-\u1EFF])?\.)+[a-zA-Z]{2,}$/;
/* eslint-enable */
